var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0566 15.0576C15.5773 14.5369 16.4217 14.5369 16.9424 15.0576L24.9424 23.0576C25.4631 23.5783 25.4631 24.4227 24.9424 24.9434C24.4217 25.4637 23.5772 25.4639 23.0566 24.9434L16 17.8857L8.94238 24.9434C8.42165 25.4637 7.57721 25.4639 7.05664 24.9434C6.53607 24.4228 6.53633 23.5783 7.05664 23.0576L15.0566 15.0576ZM15.0566 7.05762C15.5773 6.53692 16.4217 6.53692 16.9424 7.05762L24.9424 15.0576C25.463 15.5783 25.463 16.4217 24.9424 16.9424C24.4217 17.4631 23.5773 17.4631 23.0566 16.9424L16 9.88574L8.94238 16.9424C8.42168 17.4631 7.57734 17.4631 7.05664 16.9424C6.53653 16.4218 6.53652 15.5782 7.05664 15.0576L15.0566 7.05762Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronUp);
export default __webpack_public_path__ + "static/media/double-chevron-up.6c15f26d6429391eaa2cfe918aeb8fbb.svg";
export { ForwardRef as ReactComponent };